import DrawVideo from './drawVideo.js'
import pipeService from '../../service/pipeService.js'

export default {
    name: 'VideoView',
    components: {
    },
    props: {
    },
    data() {
        return {
            videoUrl: '',
            VideoClipData: {
                'datasetType': 'comedy',
                'videoName': 'videoname',
                'start': 60,
                'end': 63
            }           
        }
    },
    watch: {
    },
    methods: {
    },
    mounted: function () {
        const _this = this;
        _this.drawVideo = new DrawVideo('#labelsContainer');
        
        pipeService.onSelectVideo(selected => {
            let videoPath = window.location.href + "video/"+ selected + ".mp4";
            let videoInfo = {
                "videoWidth": 640,
                "videoHeight": 360,
                "fps": 29.97002997002997,
                "videoPath": videoPath,
                "type": "mp4"
            };
            _this.drawVideo.layout("#labelsContainer", videoInfo, videoPath);
        });
    }
}
